import EventTracker from "../eventTracker";
import EventTypes from "../constants/EventTypes";

export function getAdminHistories(aUserId, aUpToDate, aFromDate, aLimit, aOffset, aPatientIdOrEdcId, aItemType = null, aItemId = null){
  EventTracker.track(EventTypes.FETCH_ADMIN_HISTORIES);
  let query = `
    query getAdminHistories($company_id: ID!, $user_id: ID, $patient_id_or_edc_id: String, $item_type: String, $item_id: Int, $up_to_date: String, $from_date: String, $limit: Int, $offset: Int) {
      admin_history_page(company_id: $company_id, user_id: $user_id, patient_id_or_edc_id: $patient_id_or_edc_id, item_type: $item_type, item_id: $item_id, up_to_date: $up_to_date, from_date: $from_date, limit: $limit, offset: $offset) {
        admin_histories {
          id
          edited_at
          item_type
          edited_by {
            id
            last_name
            first_name
          }
          event_type
          change_list {
            key
            new_value
            old_value
          }
        }
        total
      }
    }
  `;
  let variables = {user_id:aUserId, up_to_date:aUpToDate, from_date:aFromDate, limit:aLimit, offset:aOffset};
  
  if(aPatientIdOrEdcId){
    variables.patient_id_or_edc_id = aPatientIdOrEdcId;
  }
  if(aItemType){
    variables.item_type = aItemType;
  }
  if(aItemId !== null && aItemId !== undefined){
    variables.item_id = parseInt(aItemId, 10);
  }
  return (dispatch, getState) => {
    let state = getState();
    variables['company_id'] = state.company && state.company.company && state.company.company.id
    return global.api.post("/queries", {query, variables});
  };
}
